
import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

window.addEventListener('frame-ready', init)

function init() {

    const container = document.querySelector('.sustainability-graphic-outer')
    const graphic = document.querySelector('.sustainability-graphic')

    if (!container || !graphic) return

    const bottles = container.querySelectorAll('.graphic-bottle')
    const images = container.querySelectorAll('.graphic-element')
    let defaultEase = 'power1.out'
    let defaultDuration = 0.5

    gsap.set(images, { opacity: 0, translateX: '0px' })

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: container,
            start: 'top 35%',
            markers: false
        }
    })

    tl.to(bottles, {
        duration: defaultDuration,
        ease: defaultEase,
        opacity: 1
    })

    tl.to(images, {
        duration: defaultDuration,
        ease: defaultEase,
        stagger: 0.3,
        opacity: 1
    })

}
